import { BodyTextContainer, ContentContainer, Heading } from '@msaf/core-react'
import { MenuLinks } from '../../../../../constants'

export default function NotFound() {
  return (
    <ContentContainer>
      <BodyTextContainer>
        <Heading level={1}>Page not found</Heading>
        <p>
          The page you're looking for does not exist, or the information you are trying to access may not have been
          published yet.
        </p>
        <p>
          Return <a href={MenuLinks.LANDING}>home</a> or&nbsp;<a href={MenuLinks.CONTACT_US}>contact us</a> if the
          problem persists.
        </p>
      </BodyTextContainer>
    </ContentContainer>
  )
}
